import 'reflect-metadata';

export * from '@gongxigames/framework/core';
export * from './types';
export * from './events';

export * from './fragments/module/Module';
export * from './fragments/module/ModuleState';
export * from './fragments/module/view';
export * from './fragments/SoundsDuckingConfig';
export * from './fragments/SplashScreenWarper';
export * from './fragments/Xhr';

export * from './utils';
export * from './modules';

export * from './services/AutotestService';
export * from './services/LoggerService';
export * from './services/GameInfoService';
export * from './services/PixiJSDevtoolsService';
export * from './services/ReelsConstantsService';
export * from './services/ReelsScaleService';
export * from './services/ResourcesManager';
export * from './services/SoundManager';
export * from './services/SoundPlayer';
export * from './services/SplashScreenService';
export * from './services/StatsService';
export * from './services/WinPresentationUtils';
export * from './services/TemplateUtils';
export * from './services/PrizeSymbolsUtils';
export * from './services/InitializationEnvironmentSettingsService';
export * from './services/ScaleService';

export * from './services/logic';

export * from './configs/RichTextConfig';
export * from './configs/SpecialWinTypeConfig';
export * from './configs/DI';
export * from './configs/messages';
export * from './configs/reasonAutoplayStop';
export * from './configs/components/slotComponentsConfig';
export * from './configs/slotGameConfig';
export * from './configs/SpecialWinTypeConfig';
export * from './configs/SoundConfig';
export * from './configs/HotModuleReplacementConfig';
export * from './configs/SlotSettings';
export * from './configs/defaultTexts';
export * from './configs/defaultReelsScaleConfig';
export * from './configs/defaultReelsScaleConfig';
export * from './configs/Layers';
export * from './configs/scenes';

import * as messages from './configs/messages';

export {messages};

export * from './runSlot';
